export default __webpack_public_path__ + "static/media/nocon.f4442e21.png";